import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/site";

const REFRESH_MS = 10 * 60 * 1000;

export function useNews(limit = 30, topic = null) {
  const [data, setData] = useState({ items: [], total: 0, last_updated: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/news`, { params: topic ? { limit, topic } : { limit } });
      setData(res.data);
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [limit, topic]);

  useEffect(() => {
    load();
    const t = setInterval(load, REFRESH_MS);
    return () => clearInterval(t);
  }, [load]);

  return { ...data, loading, error, reload: load };
}
